import AwardsSection from './AwardsSection';

export default AwardsSection;
